import { POD_STATUS } from './../components/OperationComponent/Operation/OperationDetail/PODDispatch/PodBarcodeComponent';
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import moment, { type Moment } from "moment";
import { AuthenticationHook, NewAuthenticationHook } from "../components/RouteComponents/AuthenticationHook";
import {
  AccessConfig,
  Product,
  type AccountInterface,
  type IProductType,
  type ISubProductList,
} from "../model/BookingModel";
import { type IDropDown } from "../model/CommonModel";
import {
  ONE_MONTH,
  ONE_WEEK,
  SUBTRACT,
  momentMonthsDate,
  momentTodayDate,
  weekDate,
  yesterdayDate,
} from "./luxon";
import { message, notification } from 'antd';
import { LatLng } from '../components/DashboardComponent/DriverDashboard/interface';
import * as XLSX from "xlsx";
import L, { DivIcon } from 'leaflet';

export const isProdMode = (): boolean =>
  process.env.REACT_APP_ENV === "production";

export const EMAIL_PLACEHOLDER = "email@address.com",
  DELETE_MESSAGE = "Are you sure you want to delete?",
  DELIVERY_MESSAGE = "Are you sure you want to delivery?",
  REVERT_MESSAGE = "Are you sure you want to revert?",
  TRIP_CONFIRMATION_MESSAGE =
    "Driver is already assigned, do you want to update the trip?",
  PICKUP_DATE_ERROR = "Pickup date should be less than delivery date",
  DELIVERY_DATE_ERROR = "Delivery date should be greater than pick up date",
  END_DATE_ERROR = "End date should be less than start date",
  START_DATE_ERROR = "Start date should be greater than end date",
  INVALID_USER_NAME_OR_PASSWORD_ERROR = "Invalid Username or Password",
  NETWORK_ISSUE = "Network Issue, please try again",
  PROOF_OF_DELIVERY_ERROR_MESSAGE = "POD type should not be same.",
  VISIT_TIME_ERROR_MESSAGE = "Visit time should not be same",
  SEQUENCE_NUMBER_ERROR_MESSAGE = "Sequence number should not be same",
  ETD_ETA_MESSAGE = "The ETD should not after ETA",
  ETA_ETD_MESSAGE = "The ETA should not before ETD",
  SEQUENCE_TIME_ERROR_MESSAGE = "Sequence and Time combination is not valid",
  DELIVERY_DATE_CHANGE_MESSAGE =
    "Are you sure you want to change the delivery date?",
  GREATER_VALUE_MESSAGE = "This value should not be greater than",
  ACCOUNT_IS_BLOCKED = "The selected account is blocked",
  CONTACT_ADMINISTRATOR = "Please contact your administrator",
  FOD_ERROR_TITLE = "FOD NOT AVAILABLE",
  FOD_ERROR_MESSAGE = "FOD option is not available in the selected agreement",
  TOTAL_COUNT = "Total count cannot be less or equal to zero",
  PENDING_STATUS_ID = 5,
  DUPLICATE_PENDING_STATUS_ID = 8,
  ACTIVE_STATUS_ID = 1,
  DE_ACTIVE_STATUS_ID = 2,
  DELETE_STATUS_ID = 3,
  IS_CANCELLED_STATUS_ID = 4,
  BOOKING_REJECTED_ID = 3,
  QUOTATION_APPROVE = "approve",
  QUOTATION_REJECTED = "reject",
  BOOKING_APPROVED_ID = 2,
  BOOKING_NEW_BOOKING_ID = 1,
  ACCOUNT_ID = 1,
  CASH_ID = 2,
  FOD_ID = 5,
  ACCOUNT_WITHOUT_AGREEMENT = "Account without Agreement",
  ACCOUNT_WITHOUT_AGREEMENT_ID = 5,
  NO_POD_ID = 4,
  CASH_ON_DELIVERY = 3,
  FREE_OF_COST = 4,
  YYYY_MM_DD_HH_mm = "YYYY-MM-DD HH:mm",
  YYYY_MM_DD = "YYYY-MM-DD",
  DD_MM_YYYY = "DD-MM-YYYY",
  YYYY_MM_DD_DATE_FORMAT = "yyyy-MM-dd",
  DD_MM_YYYY_DATE_FORMAT = "dd-MM-yyyy",
  DD_MM_YYYY_H_MM = "dd-MM-yyyy HH:mm",
  DD_MM_YYYY_H_MM_SS = "dd-MM-yyyy HH:mm:ss",
  YYYY_MM_DD_H_MM_SS = "yyyy-MM-dd HH:mm:ss",
  DD_MM_YYYY_HH_mm = "DD/MM/YYYY HH:mm",
  BOOKED = "Booked",
  BOOKING_CONFIRMED = "Booking Confirmed",
  BOOKING_COMPLETED = "AJ0003",
  BOOKING_CANCELED = "Booking Canceled",
  BOOKING_REJECTED = "Booking Rejected",
  PICKUP_DRIVER_ASSIGNED = "AJ0005",
  PICKUP_DRIVER_ACKNOWLEDGED = "AJ0006",
  PICKED_UP = "AJ0007",
  RECEIVED_AT_HUB = "Received at Hub",
  DELIVERY_DRIVER_ASSIGNED = "AJ0009",
  DELIVERY_DRIVER_ACKNOWLEDGED = "Delivery Driver Acknowledged",
  DELIVERED = "Delivered",
  PICKED = "Picked Up",
  LOAD_TO_DEST = "AJ0012",
  ARRIVED_AT_TRANSIT = "AJ0013",
  ACTIVE = "Active",
  ACTIVE_ID = 1,
  PENDING = "Pending",
  DE_ACTIVE = "De-Active",
  DE_ACTIVE_ID = 2,
  IS_CANCELLED = "Is-Cancelled",
  ON_ACCOUNT = "On Account",
  ACCOUNT = "Account",
  CASH = "Cash",
  FOD = "FOD",
  DATA_LOGGER_FILE = "Data Logger File",
  MARKEN_FILE = "Marken",
  MANIFEST_FILE = "Manifest File",
  NO_POD = "No POD",
  FREE_OF_COST_TEXT = "Free Of Cost",
  TRAY_TYPE = "TRAY",
  BOX_TYPE = "BOX",
  RE_SCHEDULE = "Re-Schedule",
  DISABLED_TIME = 3,
  FILE_UPLOAD_FINANCE_ID = 2,
  //Status Code
  SUCCESS_CODE = 100,
  TWO_HUNDRED_SUCCESS_CODE = 200,
  ONE_HUNDRED_SUCCESS_CODE = "100",
  THREE_HUNDRED_TWO_CODE = "302",
  FIFTY_FOUR = 54,
  EIGHTY_CODE = 80,
  SEVENTY_CODE = 70,
  FOUR_ZERO_ONE = 401,
  FOUR_HUNDRED = 400,
  FOUR_HUNDRED_NINE = 409,
  FIVE_HUNDRED = 500,
  START_RTO_CODE = 998,
  THREE_HOURS_MILLISECONDS = 10800000,
  THIRTY_MIN_MILLISECONDS = 1800000,
  // normally TABLE_HEADER_HEIGHT would be 55.
  TABLE_HEADER_HEIGHT = 55,
  NO_RECORD_FOUND = "No Record Found",
  COMPLETE_RTO_CODE = 999,
  // Trip
  ACTIVE_TRIP_STATUS_ID = 1,
  DE_ACTIVE_TRIP_STATUS_ID = 3,
  DELETE_TRIP_STATUS_ID = 2,
  DELAY_REASON_EXCEPTION_CATEGORY = 8,
  AONE_CANCEL_BOOKING_EXCEPTION_CATEGORY = 22,
  NAV_HEADER_HEIGHT = 65,
  SHIPPER = "Shipper",
  CONSIGNEE = "Consignee",
  START_TRIP = "START TRIP",
  STOP_AT_TRANSIT = "STOP AT TRANSIT",
  START_AT_TRANSIT = "START AT TRANSIT",
  ARRIVED_AT_DESTINATION = "ARRIVED AT DESTINATION",
  RTO = "RTO",
  NORMAL = "Normal",
  XL = "XL",
  XXL = "XXL",
  NORMAL_ID = 9,
  XL_ID = 10,
  XXL_ID = 11,
  BANK_DEPOSIT_NUMBER_OF_WEEKS = 14,
  FINAL_INVOICE_TEXT = "Final Invoice has been issued",
  GROSS_AMOUNT_TEXT = "Gross Charge cannot be 0",
  SENT_FOR_INVOICING = "Sent for Invoicing",
  MONTHLY_BILLING = 2,
  PASSPORT_EXPIRY_MONTH = 3,
  INTERNATIONAL = "international",
  // POD dispatch
  POD_DISPATCH_CLIENT_ID = 151,
  POD_DISPATCH_PRODUCT_ID = 1,
  POD_DISPATCH_SUB_PRODUCT_ID = 1,
  POD_DISPATCH_TEMPERATURE_ID = 1,
  PRINT_OR_CANCEL_MESSAGE = "if you want to Print. Press Print or Cancel",
  CN_REQUEST_NUMBER = "CN Request Number",
  DN_REQUEST_NUMBER = "DN Request Number",
  FTL_TOTAL_PIECES = "FTL will have only 1 total pieces",
  WEIGHT_ORIENTED_PRODUCT_MESSAGE =
    "This service will be charge based on actual weight of total number of packages as according to the agreed rates",
  WEIGHT_ORIENTED_PRODUCT_HEADER = "Weight Oriented Product",
  PALLET_ORIENTED_SERVICE_HEADER = "Pallet Oriented Service",
  PALLET_ORIENTED_MESSAGE =
    "This service will be charge for number of pieces and the size of the pieces as according to the agreement.",
  PIECES = "Pieces ",
  PIECES_MESSAGE_ONE =
    "If Courier collect package as a box, then charges will be applied for each box. ",
  PIECES_MESSAGE_TWO = `If courier collect the package a pelletized cargo, then the charges will be applied for each pallet`,
  CREATE_BOOKING_FILE = "Create Booking File",
  BOOKING = "booking",
  ONE_MB_TO_BYTES = 1000000,
  TWO_MB_TO_BYTES = 2000000,
  TWENTY_TWO_MB_TO_BYTES = 22000000,
  FIVE_MB_TO_BYTES = 5000000,
  ERROR = "Error",
  ENQUIRY_CREATED_ID = 1,
  QUOTATION_CREATED_ID = 2,
  PADDING_LENGTH = 13,
  QUOTATION_VALIDATE_MILLISECONDS = 1708848881000, //"2024-02-25"
  FILE_SIZE_EXCEEDS = "Uploaded file should not be greater than 2 MB",
  FILE_SIZE_EXCEEDS_5_MB = "Uploaded file should not be greater than 5 MB",
  MARKEN_CUSTOMER = "AJ000116001",
  MARKEN_CUSTOMER_ACCOUNT_2 = "AJ000116002",
  AJEX_KSA_FFD_CCN = "AJ0000000029012",
  DUPLICATE_AGREEMENT_ID = 8,
  QUOTATION_REJECT_ID = 2,
  SAUDI_ARABIA_CODE = "SA",
  QUOTATION_APPROVED_ID = 1,
  EXCEPTION_REASON_ID = 1,
  BOOKING_EXCEPTION_ID = 3,
  REJECT_REASON_ID = isProdMode() ? 10 : 16,
  HOLD_AND_TERMINAL = 10, // TODO:Change to 10
  VAT_NA_ID = 0,
  AJEX_OWNER = 2,
  CUSTOMER_COMPLAINT = "Customer Complaint",
  SELLING_COST_ERROR_MESSAGE = "Selling price should not be less than cost",
  COST_PRICE_ERROR_MESSAGE = "Cost price cannot be more than selling",
  RANGE_UNIT = 15,
  KILOGRAM_UNIT = 1,
  UN_ASSIGN_MESSAGE = "Are you sure , you want to un-assigned",
  EMPTY_VEHICLE_TYPE_AND_VEHICLE_NUMBER_AND_COST_AND_SUPPLIER_TEXT =
    "Vehicle Type and Vehicle Number and supplier name and cost in the costing module cannot be empty",
  OFD = "Out For Delivery",
  HEAD_ONLY = 3,
  PICKUP_EXCEPTION = 'Pickup Exception',
  NOT_DELIVERED = 'Not Delivered',
  AD_HOC_ID = 62,
  TRIP_OPEN = 'Open',
  CBM_UNIT = 2,
  LOAD_TO_DESTINATION = "Load to Destination",
  ARRIVED_AT_DEST = "Arrived at Dest",
  POD_EXCEPTION = 7,
  CANCEL_PICKUP_FILE = "Cancel Pickup File",
  IRS = 9,
  PALLET_UNIT_ID = 4,
  CANCEL_BOOKING_CATEGORY = 14, // change !!!
  MARKEN_CUSTOMER_ID = isProdMode() ? 169 : 659,
  INTERNATIONAL_ROAD_PALLETS = 5,
  TRIP_EXCEPTION = 'Trip Exception',
  DOMESTIC_ROAD_EXPRESS = 1,
  RANGE_FIXED = 16,
  RANGE_BASED_FIXED = 17,
  DELIVERY_REVERT_CATEGORY = isProdMode() ? 16 : 17,
  RangePriceID = 18,
  MULTIPLIER_UNIT = 12,
  DOMESTIC_ROAD_PALLET = 2,
  PICKUP_EXCEPTION_CATEGORY = "Pickup Exception",
  DELIVERY_EXCEPTION_CATEGORY = "Delivery Exception",
  LIFE_SCIENCE = "Life Science",
  DELIVERY_RESCHEDULE_CATEGORY = 18,
  HOLD_TERMINAL_EXCEPTION_CATEGORY = "Hold & Terminal Exception",
  CONSIGNEE_CHANGE_ADDRES_CATEGORY = 19,
  VOLUMETRIC_UNIT = 3,
  SAUDI_COUNTRY_ID = 16,
  POSS_CLIENT_ID = isProdMode() ? 61 : 203,
  POSS_SUB_CLIENT_ID = isProdMode() ? 113 : 213; // FOR STAGING


export const ACCOUNT_INACTIVE_EXCEPTION = 'Account Inactive Exception';
export const ACCOUNT_INACTIVE_EXCEPTION_ID = 390; // 390
export const BLOCKED_STATUS = "blocked";


export enum PRODUCT_TYPE {
  DOMESTIC_ROAD_EXPRESS = "Domestic Road Express",
  DOMESTIC_TEMP_EXPRESS = "Domestic Temp Express",
  INTERNATIONAL_ROAD_EXPRESS = "International Road Express",
  INTERNATIONAL_TEMP_EXPRESS = "International Temp Express",
  DOMESTIC_ROAD_PALLETS = "Domestic Road Pallets",
  DOMESTIC_ROAD_PALLET = "Domestic Road Pallet",
  DOMESTIC_TEMP_BOX = "Domestic Temp box",
  DOMESTIC_TEMP_ECONOMIC = "Domestic Temp Economy",
  INTERNATIONAL_ROAD_PALLETS = "International Road Pallets",
  INTERNATIONAL_TEMP_ECONOMIC = "International Temp Economy",
  INTERNATIONAL_LTL = "International LTL",
  INTERNATIONAL_ROAD_FREIGHT_EXPRESS = "International Road Freight Express",
  LIFE_SCIENCE_EXPRESS = "Life Science Express",
  LIFE_SCIENCE_EXPRESS_PLUS = "Life Science Express Plus",
  DOMESTIC_TEMP_PALLETS = "Domestic Temp Pallets"
}

export const FileEnums = {
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  IMAGE_PNG: "image/png",
  IMAGE_JPG: "image/jpg",
  IMAGE_JPEG: "image/jpeg",
  APPLICATION_PDF: "application/pdf",
  APPLICATION_MS_WORD: "application/msword",
  EMAIL: "message/rfc822",
  APPLICATION_DOCUMENT:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
} as const;
export const exportArrayToExcel = async (
  data: Array<Record<string, any>>,
  fileName: string,
  sheetName = "Sheet1"
) => {
  if (!data || data.length === 0) {
    message.warning("No records found to export");
    return;
  }
  const XLSX = await import("xlsx");
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const scheduleTrip = [
  {
    id: 1,
    label: "Daily",
  },
  {
    id: 2,
    label: "Weekly",
  },
];

export const arabicLetter =
  "\u0623\u0628\u062D\u062F\u0631\u0633\u0635\u0637\u0639\u0642\u0643\u0644\u0645\u0646\u06BE\u0648\u06CC";

export const applicationTimer = !isProdMode()
  ? THREE_HOURS_MILLISECONDS
  : THIRTY_MIN_MILLISECONDS;

export const fileExclude: (type: string) => boolean = (type: string) =>
  [FileEnums.IMAGE_PNG, FileEnums.IMAGE_JPG, FileEnums.IMAGE_JPEG]
    .toString()
    .includes(type);

export const fileInclude: (type: string) => boolean = (type: string) =>
  [
    FileEnums.EXCEL,
    FileEnums.IMAGE_PNG,
    FileEnums.IMAGE_JPG,
    FileEnums.IMAGE_JPEG,
    FileEnums.EXCEL,
    FileEnums.APPLICATION_DOCUMENT,
    FileEnums.APPLICATION_MS_WORD,
    FileEnums.APPLICATION_PDF,
  ]
    .toString()
    .includes(type);

export enum Status {
  INTRACITY = 4,
  ALL = 5,
}

export enum VehicleTypeIds {
  AD_HOC = 62,
  NO_FLEET = 30,
}
export const FtlProductTypeNames = ["Domestic FTL", "Domestic Temp FTL"];

export enum UserEnum {
  MANAGER = 1,
  DRIVER = 3,
  OPERATION_SUPERVISOR = 4,
  CUSTOMER_SERVICE = 5,
  MANIFESTER = 6,
  ADMIN = 7,
  SALES_PERSON = 8,
  SALES_MANAGER = 9,
  FINANCE = 10,
  DATA_ANALYST = 11,
  FLEET_SUPERVISOR = 12,
  OPERATION_CS_SUPERVISOR = 13,
  OPERATION_STAFF = 14,
  SALES_DIRECTOR = 15,
  OPERATOR_CASH_COLLECTOR = 16,
  OPERATION_SUPERVISOR_CASH_COLLECTOR = 17,
  CSV = 18,
  OPS_MANAGER = 19,
  COMMERCIAL_SUPPORT_ROLL = 20,
  FINANCE_CONTROLLER = 22,
  DATA_LOGGER = 23,
  QUOTATION = 24,
  CUSTOMER_CARE = 26,
  OCC_SOLUTION = 27,
  OPERATION_SUPERVISOR_OPERATION_STAFF = 28,
  OPS_CASH = 21,
  OPERATION_CS_SUPERVISOR_MANIFESTER = 29, // Operation CS Supervisor +  Manifest
  GATEWAY_USER = 30,
  LEGAL_USER = 32,
  IT_SUPPORT = 31,
  A_ONE = 33
}


export const CRO_POSITIONS = {
  "positionList": [
    UserEnum.CUSTOMER_CARE,
    UserEnum.CUSTOMER_SERVICE,
    UserEnum.SALES_DIRECTOR,
    UserEnum.SALES_PERSON,
    UserEnum.SALES_MANAGER,
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
    UserEnum.COMMERCIAL_SUPPORT_ROLL,
    UserEnum.CUSTOMER_CARE,
    UserEnum.OCC_SOLUTION,
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
  ]
}


export enum CountryEnum {
  KSA = 16,
  UAE = 19,
  BAHRAIN = 218,
  YEMEN = 11,
  KUWAIT = 42,
  EGYPT = 20,
  OMAN = 54,
  QATAR = 56,
  // IRAN = 6,
  IRAQ = 102,
  JORDAN = 78,
  SUDAN = 27,
  LEBANON = 129
}


export enum NotValidGoodTypesEnum {
  TEST = 1,
  AGRICULTURAL = 4,
  INDUSTRIAL = 5,
  MINING_OR_FOSSILIZATION_MATERIALS = 6,
  PETROLEUM_PRODUCTS = 10,
  LIVE_ANIMALS = 11,
  FOOD_ITEMS = 12,
  VEHICLE_TRANSPORTATION = 13,
  BUILDING_AND_CONSTRUCTION_ITEMS = 34,
  DANGEROUS_MATERIALS = 35,
  SANITATION = 125,
  WATER_TANKS = 126,
  GAS_TANKS = 127,
  SPARES = 129,
  REINFORCING = 131,
  FURNITURE = 133,
  CHEMICALS_MATERIALS = 136,
  PREFABRICATED_HOUSES = 140,
  WASTE_MATERIAL = 141,
  CLOTHES_AND_SHOES = 147,
  CHARCOAL_AND_FIREWOOD = 148,
  MEDICINES = 149,
  VETERINARY_MEDICINES = 153,
  BICYCLES = 154,
  MOTORBIKES = 155,
  MEDICAL_SUPPLIES_AND_HOSPITAL_SUPPLIES = 156,
  BOOKS = 157,
  ELECTRICITY_GENERATORS = 159,
  TEXTILE_AND_SEWING_MATERIALS = 160,
  TOBACCO_PRODUCTS = 161,
  BUILDING_WASTE = 162,
  BASIC_PHARMACEUTICAL_PRODUCTS_AND_PHARMACEUTICAL_PREPARATIONS = 163
}


export const phoneCode = {
  SA: "+966",
  UAE: "+971",
  BAHRAIN: "+973",
  QATAR: "+974",
  YEMEN: "+967",
  KUWAIT: "+965",
  IRAQ: "+964",
  JORDAN: "+962",
  EGYPT: "+20",
} as const;

export enum ComplaintRatingEnum {
  Satisfied = 1,
  Medium = 2,
  NotSatisfied = 3,
}

export enum NonPlateNumberUnit {
  Curtain_Side_Trailer = 14,
  Reefer_Trailer = 18,
  Flat_Bed_Trailer = 23,
  FORKLIFT = 27,
  Trailer_Curtain_Side = 30,
  Trailer_Box = 31,
  Trailer_Drop_Side = 32,
  Trailer_Low_Bead = 33,
  Trailer_High_Cube = 34,
  Trailer_Reefer = 35,
  Trailer_Flat_Bed = 36,
  VNA = 50,
  Reach_Truck = 51,
  Pallet_Truck = 53,
  Dry_Box = 17,
}
export enum ManifestTypeEnum {
  Domestic = 0,
  IRS = 1,
}

export enum Employee {
  PRANEETH = 683,
  ALANOUD = 733,
  FARAH = 1224,
  HALA = 10912,
  GOIUSE = 1532,
  BALA = 685,
  ANIS_BISWAS = 1265,
  PANDI = 1321,
  ARWA = 101,
  ARWA_FINANCE = 710,
  MATEEN_DEV = 238,
  MATEEN_PROD = 111,
  HAJJAJ = 667,
  IMRAN_PASHA = 1006,
  VISHNU = 900426,
  PRANEETH_DEV = 684,
  // PRICING TEAM
  IMATHUL_RAFI = 1299,
  KAMARU_ZAMAN = 1874,
  MUSTHAFA_PALAPPETTY = 1030,
  JAYA_CHANDRAN = 1227,
  ALQUWAH = 1230,
  LARA = 977,
  MOHAMMED_SAMI = 2123,
  MOHAMMED_AL_QUWAH = 1230,
  AYMAN_ALMARKHI = 2528,
  JISHNU_KOLADAPANACKAL = 992,
  REEM_ABDULLAH_ALJAMEA = 814,

  AJITH_KOOLIKKUNNUMMEL = 1005,
  SHIVRIN = 2704,
  SAEED_AHAMAD = 3219,
  TURKI_ALBUWAYDI = 722,
  MAJAD_ALI = 1240,
  BIJOY = 1262,
  SHAJAHAN_SHAMSUDEEN = 783,
  ASIF_PATEL = 1536,
  MAHTAB_ALI = 863,
  PRASANTH_RAMACHANDRAN = 1040,
  MOHAMED_RIYAS = 1033,
  IRSHAD_ALI_VELAPURATH = 1569,
  ASRAF_ALI = 857,
  MOHAMMED_ALJOHANI = 1249,
  EJAZ_BEIG = 2691,
  HASSAN_ALMIRZA = 2846,
  VIGNESHWARAN = 1396,
  AMIR_GHAAFFAR = 2697,
  MOHAMMED_IBRAHIM_SHAREEF = 1060,
  BANDER_ALLAFI = 3021,
  HUZAIL_AKHTER = 3026,
  FARAH_ALMUTAIRI = 1224,
  AAMIR_MEHBOOB = 0,
  LLOYD_D_SARINO = 0,
  FAISAL_HAKAMI = 0,
  MOHAMMED_IMRAN = 0,
  MOHAMMED_LUQMAN = 1403,
  JAWAHER_ALHARBI = 2968,
  IMATHUL_RAFI_KSA = 1299001,
  SAMPATH_PUSHPAKUMARA = 1747,
  MARYAM_ALLAF = 2048,
  MAKESH_MANIKANDAN = 2228,
  FAISAL_ALAHMARE = 1482,
  MUZAMMIL_KHAN = 1373,
  KAUSHIK_SAMPAT = 3104,
  ANANDHAN_NAGARAJAN = 30103,
  KHUSBEER_SINGH = 900423,
  MAHAMED_ARIF_SHAH_MADAR = 2494,
  PRATHYOOD_JAGADEESH = 2313,
  ARCHE_MISRA = 2495,
  HAMMAD_MAROOF = 2721,
  ARJUN_KUMAR = 3290,
  NOHA_KARKADAN = 2945,
  SAFAA_MOHAMMED_HAWSAWI = 3187,
  GHADEER_ALQHTANI = 1394,
  ALMAHA_ALANAZI = 2861,
  JAMELAH_IBRAHIM_ALI = 2367,
  UDAYA_MOGER = 2732,
  Muath_Al_Abdulmunem = 3330,
  Suhail_Mustafa = 3280,
  SATHISH_KUMAR = 30126,
  KRISHAN_THRIPURA = 3149,
  Almaha_Alanazi = 2861,
  Roaa_Arnaout = 3362,
  GOPINATH = 280101,
  Nouf_AlOmar = 2909,
  MOHAMMAD_FAIZAN_ALAM = 2489,
  ABDELRAHMAN = 3390,
  Abdulrahman_ElShafai = 3390,
  MOHMED_RIFKHAN = 900433,
  ELEMAM_ELEMAM = 2468,
  Sebastian_Sommer = 3410,
  Abdoulaye_Sarr = 3288,
  Faisal_Abdullah_Nasser = 7613,
  Abdulrahman_Jamal = 3156,
  ELAF_SARHAN = 2957,
  ASHWAQ_ALANEZ = 3077,
  Khaznah_Aldossari = 1102,
  Muhammed_Ahmed_Khan = 3102,
  Khalid_Ajlan_Alharthi = 3339,
  MOUSTAFA_MAHMOUD = 3380
}

export enum PositionEnum {
  MANAGER = 1,
  ADMIN = 7,
  OPS_MANAGER = 19,
  MANIFESTER = 6,
  FINANCE = 10,
}

export const SUB_CITY_ACCESS = {
  DOMESTIC_FTL: "domestic ftl",
  DOMESTIC_TEMP_FTL: "Domestic Temp FTL",
} as const;

export const blobConfiguration: AxiosRequestConfig<unknown> = {
  responseType: "blob",
  timeout: 30000,
};

export const downloadURLs = async (urls: string[]) => {
  urls.forEach((url) => downloadURL(url));
};

export const downloadURL = async (url: string | unknown) => {
  if (typeof url === "string") {
    try {
      // Fetch the file
      const response = await fetch(url, {
        mode: "no-cors",
      });
      if (!response.ok) {
        downloadFile(url, "application/pdf");
        //throw new Error(`Unable to download file. HTTP status: ${response.status}`);
      }
      // Check if the request was successful
      if (response.ok) {
        const blob = await response.blob();
        const { type } = blob;
        downloadFile(blob, type, "download");
      }
    } catch {
      console.error(`Unable to download file`);
    }
  }
};

export const downloadFiles = (
  response: AxiosResponse<unknown, unknown> | undefined
) => {
  if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
    const rawContentType = response?.headers?.["content-type"];
    const contentType = typeof rawContentType === "string" ? rawContentType : undefined;

    const [, fileName] =
      response?.headers?.["content-disposition"]?.split("filename=") ?? [];

    downloadFile(response?.data, contentType, fileName);
  }
};

export const fileFormat: Record<string, string> = {
  // Documents
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  txt: "text/plain",
  rtf: "application/rtf",
  csv: "text/csv",
  odt: "application/vnd.oasis.opendocument.text",
  excel: FileEnums.EXCEL,
  rfc822: FileEnums.EMAIL,

  // Images
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  svg: "image/svg+xml",
  ico: "image/vnd.microsoft.icon",
  tif: "image/tiff",
  tiff: "image/tiff",

  // Audio
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  m4a: "audio/mp4",
  flac: "audio/flac",
  aac: "audio/aac",

  // Video
  mp4: "video/mp4",
  webm: "video/webm",
  avi: "video/x-msvideo",
  mov: "video/quicktime",
  mkv: "video/x-matroska",
  mpeg: "video/mpeg",
  "3gp": "video/3gpp",

  // Archives
  zip: "application/zip",
  rar: "application/vnd.rar",
  tar: "application/x-tar",
  gz: "application/gzip",
  "7z": "application/x-7z-compressed",

  // Code
  js: "application/javascript",
  jsx: "text/jsx",
  ts: "application/typescript",
  tsx: "text/tsx",
  html: "text/html",
  css: "text/css",
  json: "application/json",
  xml: "application/xml",
  yaml: "application/x-yaml",
  yml: "application/x-yaml",
  php: "application/x-httpd-php",
  py: "text/x-python",
  java: "text/x-java-source",
  cpp: "text/x-c",
  c: "text/x-c",

  // Fonts
  ttf: "font/ttf",
  otf: "font/otf",
  woff: "font/woff",
  woff2: "font/woff2",

  // Others
  epub: "application/epub+zip",
  mobi: "application/x-mobipocket-ebook",
  apk: "application/vnd.android.package-archive",
  exe: "application/vnd.microsoft.portable-executable",
  dmg: "application/x-apple-diskimage",
  iso: "application/x-iso9660-image"
};


const downloadFile = (
  response: any,
  applicationType: string | undefined,
  fileName?: string
) => {
  const url =
    response instanceof Blob
      ? window.URL.createObjectURL(
        new Blob([response], { type: applicationType })
      )
      : response;
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  fileName && link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};




const sanitizeFileName = (fileName: string): string => {
  return fileName
    .replace(/[:*?"<>|\\\/]/g, '-')  // Replace invalid characters with hyphens
    .replace(/\s+/g, '_')            // Optional: Replace spaces with underscores
    .substring(0, 255);              // Limit file name length (optional)
};
export const downloadBlob = async (
  response: unknown,
  fileName: string,
  fileType = "application/pdf"
) => {
  const fileFormat: Record<string, string> = {
    pdf: "application/pdf",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    txt: "text/plain",
    csv: "text/csv",
    json: "application/json",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };

  const normalizedType = fileType.includes('/')
    ? fileType
    : fileFormat[fileType.toLowerCase()] || 'application/octet-stream';

  const safeFileName = sanitizeFileName(fileName);
  const href = `data:${normalizedType};base64,${response}`;

  try {
    const res = await fetch(href);
    const blob = await res.blob();
    downloadFile(blob, normalizedType, safeFileName);
  } catch (err) {
    console.error("Failed to download file:", err);
  }
};



export function Base64ToFileCRM(base64: string, fileName: string) {
  if (base64) {
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([array], { type: "application/pdf" });
    const file = new File([blob], fileName, { type: "application/pdf" });
    const objectUrl = window.URL.createObjectURL(file);
    const downloadLink = document.createElement("a");
    downloadLink.href = objectUrl;
    downloadLink.download = fileName;
    downloadLink.click();
  }
}

export const tableColorCode: Record<string | number, string> = {
  [BOOKED]: "processing",
  [DELIVERED]: "success",
  [BOOKING_CANCELED]: "error",
  [RECEIVED_AT_HUB]: "warning",
  [DELIVERY_DRIVER_ACKNOWLEDGED]: "#2db7f5",
  [ACTIVE]: "#2db7f5",
  [PENDING]: "processing",
  [DE_ACTIVE]: "error",
  [CASH]: "success",
  [ON_ACCOUNT]: "#2db7f5",
  [FREE_OF_COST_TEXT]: "error",
  [BOOKING_REJECTED_ID]: "error",
  [BOOKING_APPROVED_ID]: "success",
  [BOOKING_NEW_BOOKING_ID]: "processing",
  [QUOTATION_APPROVE]: "success",
  [QUOTATION_REJECTED]: "error",
};

export const englishPlateNumberLetters = [
  {
    id: "A",
    name: "A - أ",
  },
  {
    id: "B",
    name: "B - ب",
  },
  {
    id: "J",
    name: "J - ح",
  },
  {
    id: "D",
    name: "D - د",
  },
  {
    id: "R",
    name: "R - ر",
  },
  {
    id: "S",
    name: "S - س",
  },
  {
    id: "X",
    name: "X - ص",
  },
  {
    id: "T",
    name: "T - ط",
  },
  {
    id: "E",
    name: "E - ع",
  },
  {
    id: "G",
    name: "G - ق",
  },
  {
    id: "K",
    name: "K - ك",
  },
  {
    id: "L",
    name: "L - ل",
  },
  {
    id: "Z",
    name: "Z - م",
  },
  {
    id: "N",
    name: "N - ن",
  },
  {
    id: "H",
    name: "H - ه",
  },
  {
    id: "U",
    name: "U - و",
  },
  {
    id: "V",
    name: "V - ى",
  },
];

export function getRandom() {
  return Math.random();
}
export const isEmptyCheck = (value: string | undefined | null) =>
  ["", undefined, null].includes(value);

export const isEmptyObject = (obj: {} | undefined) =>
  obj != null && Object.keys(obj).length === 0;

export const isNotEmptyObject = (obj: {} | undefined) =>
  (obj != null && Object.keys(obj).length) || false;
export const getSubClient = (
  productId: number,
  accountDetailList: IProductType[],
  subProductId?: number
) => {
  return accountDetailList
    ?.filter((item) => item?.productId === productId)
    .flatMap((item) =>
      item?.subProductList
        ?.filter((i) => i?.subProductId === subProductId)
        ?.map((subProduct) => ({
          ...subProduct,
          id: subProduct?.subProductId,
          value: subProduct?.subProductName,
        }))
    );
};

export const getSubClientList = (
  productId: number,
  accountDetailList: IProductType[]
) => {
  return (
    accountDetailList
      ?.filter((item) => item?.productId === productId)
      .flatMap((item) =>
        item?.subProductList?.map((subProduct) => ({
          ...subProduct,
          id: subProduct?.subProductId,
          value: subProduct?.subProductName,
        }))
      ) || []
  );
};

export const getTemperatureList = (
  subProductId: number,
  subClientList: ISubProductList[]
) => {
  return (
    subClientList
      ?.filter((item: ISubProductList) => item?.subProductId === subProductId)
      .flatMap((item: any) =>
        item.temperatureList?.map((temperature: any) => ({
          id: temperature?.temperatureId,
          value: temperature?.temperature,
        }))
      ) || []
  );
};

export const getTemperatureFromSubClient = (subClientList: ISubProductList) => {
  return (
    subClientList?.temperatureList?.map((temperature) => ({
      id: temperature?.temperatureId,
      value: temperature?.temperature,
      range: temperature?.range,
      temperature: temperature?.temperature,
      temperatureId: temperature?.temperatureId,
    })) || []
  );
};

export const accountListMap = (
  list: any[],
  id: string,
  code: string,
  name: string
) => {
  return (
    list
      ?.map((item) => ({
        ...item,
        id: item?.[id],
        value: `${item?.[code]} - ${item?.[name]}`,

      }))
      ?.sort((a, b) => sortBy(a, b)) || []
  );
};
export const dropDownMapping = (
  list: IDropDown[] | any[] | undefined,
  key: string,
  value: string,
  appendValue?: string,
  appendText: string = "%"
) => {
  return (
    list
      ?.map((item: IDropDown | any) => ({
        ...item,
        id: item[key],
        value:
          appendValue && !isEmptyCheck(item[appendValue])
            ? `${item[value]} - ${item[appendValue]} ${appendText}`
            : item[value],
      }))
      ?.sort((a, b) => sortBy(a, b)) ?? []
  );
};

export const convertSetToArray = <T>(data: T[]) => [...data];

export const getSelectedAccount = (
  accountList: AccountInterface[],
  id: number
) => {
  const { accountId, accountName } =
    accountList?.find((account: any) => account?.subClientId === id) ?? {};
  return { accountId, accountName };
};

export const disabledDateFromYesterday = (currentDate: Moment) =>
  currentDate < yesterdayDate();
export const enableDate = (currentDate: Moment, weeks: number = ONE_WEEK) =>
  currentDate < weekDate(weeks);

export const filterById = (
  list: any[] | undefined,
  filter: string,
  id: number | undefined
) => list?.filter((item) => item?.[filter] === id);

export const isAccessible = (
  access: number[],
  country: number[] = [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
  isEmployee: boolean = false
) => {
  const { isAllowed } = AuthenticationHook(access, country, isEmployee);
  return isAllowed;
};

export const isNewAccessible = (access: AccessConfig) => {
  const { isAllowed } = NewAuthenticationHook(access);
  return isAllowed;
};

export const fileToBase64 = (e) => {
  let reader = new FileReader();
  reader.readAsDataURL(e);
  return reader;
};

export function removeDuplicateObjects(arr: unknown[], property: string) {
  return [...new Map(arr?.map((obj) => [obj?.[property], obj])).values()];
}

//TODO: Duplicate eta(Visit Time) should throw an error.
export const onEtaValidator = (
  date: moment.Moment | null,
  key: number,
  formKey: string,
  list: []
) => {
  for (const item of list) {
    //If the visit time is same
    if (moment(item[formKey]).isSame(moment(date), "minute") && +item !== key) {
      return Promise.reject(new Error(VISIT_TIME_ERROR_MESSAGE));
    }
  }
  return Promise.resolve();
};

//TODO: Duplicate sequence number should throw an error.
export const onSeqNumberValidator = (
  seqNumber: number,
  key: number,
  formKey: string,
  list: []
) => {
  for (const item of list) {

    if (+item[formKey] === +seqNumber && parseInt(item) !== key) {
      return Promise.reject(new Error(SEQUENCE_NUMBER_ERROR_MESSAGE));
    }
  }
  return Promise.resolve();
};
//TODO: check if the time is greater than the previous time
export const validationCheck = (array: number[]) => {
  const length = array?.length;
  return array?.every(function (value, index) {
    let nextIndex = index + 1;
    return nextIndex < length ? value <= array[nextIndex] : true;
  });
};

export const sortedTrip = (list: any) =>
  list?.length
    ? list
      ?.sort((a: any, b: any) => +a?.seqNumber! - +b?.seqNumber!)
      .map((item: any) => item?.convertedEta ?? item?.originalEta)
    : [];

export function convertDurationToSeconds(duration) {
  return moment.duration(duration).asMilliseconds();
}

export const extractTheValue = <T extends string>(value: T) => {
  return Array.from(new Set(value
    ?.split(/[\s,]+/)
    ?.map((i) => i?.trim())
    ?.filter((i) => Boolean(i))));
};

export const getStartEndDate = (date: Moment[], months = ONE_MONTH) => {
  let startDate, endDate;
  if (date?.at(0)) {
    const startDate = moment(date[0], YYYY_MM_DD_DATE_FORMAT);
    let endDate = momentMonthsDate(startDate, months);
    if (endDate.isAfter(momentTodayDate())) {
      endDate = momentTodayDate();
    }
    return { startDate, endDate };
  }
  if (date?.at(1)) {
    const startDate = moment(date[1], YYYY_MM_DD_DATE_FORMAT);
    const endDate = momentMonthsDate(startDate, months, SUBTRACT);
    return { startDate, endDate };
  }
  return { startDate, endDate };
};

export const isFTLProduct = (productName: string) =>
  productName?.toLowerCase().includes("ftl");

export const isWeightOrientedProduct = (productName: string) =>
  [
    PRODUCT_TYPE.DOMESTIC_ROAD_EXPRESS,
    PRODUCT_TYPE.DOMESTIC_TEMP_EXPRESS,
    PRODUCT_TYPE.INTERNATIONAL_ROAD_EXPRESS,
    PRODUCT_TYPE.INTERNATIONAL_TEMP_EXPRESS,
  ]
    .toString()
    .toLocaleLowerCase()
    .includes(productName);

export const isPalletOrientedProduct = (productName: string) =>
  [
    PRODUCT_TYPE.DOMESTIC_ROAD_PALLETS,
    PRODUCT_TYPE.DOMESTIC_TEMP_BOX,
    PRODUCT_TYPE.DOMESTIC_TEMP_ECONOMIC,
    PRODUCT_TYPE.INTERNATIONAL_ROAD_PALLETS,
    PRODUCT_TYPE.INTERNATIONAL_TEMP_ECONOMIC,
  ]
    .toString()
    .toLocaleLowerCase()
    .includes(productName);

export const convertThePhoneNumber = (
  number: string,
  countryCode: string = SAUDI_ARABIA_CODE
) => number?.replace(/^0/, phoneCode[countryCode]);

export const appendZero = (value: number, totalLength: number = 13) =>
  String(value).padEnd(totalLength, "0");

export const PRICING_TEAM_USERS = isProdMode()
  ? [
    Employee.IMATHUL_RAFI,
    Employee.KAMARU_ZAMAN,
    Employee.MUSTHAFA_PALAPPETTY,
    Employee.JAYA_CHANDRAN,
    Employee.ALQUWAH,
    Employee.LARA,
    Employee.MOHAMMED_SAMI,
    Employee.MOHAMMED_AL_QUWAH,
    Employee.AYMAN_ALMARKHI,
    Employee.REEM_ABDULLAH_ALJAMEA,
    Employee.EJAZ_BEIG,
    Employee.HASSAN_ALMIRZA,
    Employee.MOHAMMED_IBRAHIM_SHAREEF,
    Employee.IMATHUL_RAFI_KSA,
    Employee.MATEEN_PROD,
    Employee.Khaznah_Aldossari
  ]
  : [Employee.MATEEN_DEV, Employee.PRANEETH_DEV];

export const isPricingTeam = () =>
  isProdMode()
    ? isAccessible(
      PRICING_TEAM_USERS,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : isAccessible([Employee.PRANEETH_DEV, Employee.MATEEN_DEV], [CountryEnum.KSA], true);

export const isBayanTeam = () =>
  isAccessible(
    [Employee.IMRAN_PASHA, Employee.SHIVRIN],
    [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
    true
  );

export const isDubaiFinance = () =>
  isAccessible(
    [Employee.IMATHUL_RAFI],
    [CountryEnum.UAE, CountryEnum.BAHRAIN, CountryEnum.KSA],
    true
  );

export const isDubaiUser = () =>
  isAccessible(
    [Employee.LARA],
    [CountryEnum.UAE, CountryEnum.BAHRAIN, CountryEnum.KSA],
    true
  );

export const isManifestIrsUser = () =>
  isAccessible(
    [Employee.Nouf_AlOmar],
    [CountryEnum.UAE, CountryEnum.BAHRAIN, CountryEnum.KSA],
    true
  );

export const isEnquiryAccess = () =>
  isAccessible(
    [UserEnum.SALES_PERSON, UserEnum.MANAGER],
    [
      CountryEnum.KSA,
      CountryEnum.BAHRAIN,
      CountryEnum.UAE,
      CountryEnum.BAHRAIN,
      CountryEnum.KSA,
    ]
  );

export const isManualWayBillAccess = () =>
  isAccessible(
    [UserEnum.MANAGER, UserEnum.DATA_LOGGER, UserEnum.SALES_PERSON, UserEnum.SALES_MANAGER],
    [CountryEnum.UAE, CountryEnum.BAHRAIN, CountryEnum.KSA]
  );

export const isFinanceApprovalAccess = () =>
  isAccessible(
    [Employee.HALA],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.BAHRAIN],
    true
  );
export const isCNDNAccess = () =>
  isAccessible(
    [Employee?.AMIR_GHAAFFAR, Employee.Abdulrahman_ElShafai, Employee?.Sebastian_Sommer, Employee?.Abdoulaye_Sarr, Employee.KAUSHIK_SAMPAT, Employee?.MOUSTAFA_MAHMOUD],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.BAHRAIN],
    true
  );


export const isCNDNDirectorApprovalAccess = () =>
  isAccessible(
    [Employee?.MOUSTAFA_MAHMOUD],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.BAHRAIN],
    true
  );

export const isCnMainPageAccess = () =>
  isAccessible(
    [Employee?.Abdulrahman_Jamal, Employee?.Abdulrahman_ElShafai, Employee?.AMIR_GHAAFFAR, Employee?.NOHA_KARKADAN],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
    true
  );


export const isMetaAgreementReportAccess = () =>
  isProdMode()
    ? isAccessible(
      [
        Employee.MATEEN_PROD,
        Employee.ALANOUD,
        Employee.FARAH,
        Employee.ELAF_SARHAN,
        Employee.ASHWAQ_ALANEZ,
        Employee.GOPINATH
      ]
      ,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : isAccessible([Employee.PRANEETH_DEV, Employee.MATEEN_DEV], [CountryEnum.KSA], true);



export const isMetaIRSManifestationReportAccess = () =>
  isProdMode()
    ? isAccessible(
      [
        Employee.MATEEN_PROD,
        Employee.HASSAN_ALMIRZA,
        Employee.GOPINATH
      ]
      ,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : isAccessible([Employee.PRANEETH_DEV, Employee.MATEEN_DEV], [CountryEnum.KSA], true);


export const expandedRowClassName = () => "expanded-row";

export function isCustomerListFiltered(
  isFiltered: boolean | undefined,
  filter: string | undefined
) {
  return isFiltered ? `?filter=${filter}` : ``;
}

const EMEARegion = [
  CountryEnum.BAHRAIN,
  CountryEnum.KSA,
  CountryEnum.UAE,
  CountryEnum.KUWAIT,
  CountryEnum.EGYPT,
  CountryEnum.OMAN,
  CountryEnum.QATAR,
  CountryEnum.IRAQ,
  CountryEnum.SUDAN,
  CountryEnum.JORDAN,
  CountryEnum.LEBANON
];

export const filterByCountryId = (list: any[], key: string) =>
  list?.filter((item) => EMEARegion.includes(item[key]));

export function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object") {
      removeEmptyObjects(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    } else if (obj[key] == null) {
      delete obj[key];
    }
  });
  return obj;
}

export function replaceWithZero(str?: string) {
  return str?.replace(/\\'+966'/g, "0");
}

export const sortBy = (a, b, key = "value") => {
  const nameA = a?.[key]?.toLocaleLowerCase();
  const nameB = b?.[key]?.toLocaleLowerCase();
  return nameA?.localeCompare(nameB);
};

const dropdownBinding = (list: IDropDown[]) => {
  return list?.map((item) => ({
    id: item?.id,
    value: item?.name,
  }));
};

export const calculateTotal = <T>({
  list,
  key,
}: {
  list: T[] | undefined;
  key: string;
}) => {
  return list?.reduce((accumulator: number, currentValue) => {
    return accumulator + +(currentValue?.[key] ?? 0);
  }, 0);
};

export const vehicleListType = {
  TRUCK: "TRUCK",
  TRAILER: "TRAILOR",
  TRACTOR_HEAD: "TRACTOR_HEAD",
};

export enum TripScanStatus {
  START_TRIP = "START TRIP",
  STOP_AT_TRANSIT = "STOP AT TRANSIT",
  START_AT_TRANSIT = "START AT TRANSIT",
  ARRIVED_AT_DESTINATION = "ARRIVED AT DESTINATION",
  TRUCK_BAN_START = "TRUCK  BAN - START",
  TRUCK_BAN_END = "TRUCK  BAN - END",
}

export enum TripPlanStatus {
  TRIP_PLAN_CREATED = "Trip plan Created",
  LOAD_TO_DESTINATION = "Load To Destination",
  OFFLOAD_AT_TRANSIT = "Offload At Transit",
  ARRIVED_AT_DESTINATION = "Arrived At Destination",
  LOAD_AT_TRANSIT = "Load At Transit",
  OPEN = "Open",
  CANCELLED = "Cancelled",
  CLOSED = "Closed",
}

export enum CustomerType {
  cashCustomer = "CASH_CUSTOMER",
  default = "DEFAULT",
}

export const ADD_HOLD_AT_TERMINAL = ["Received at Hub", "Arrived at Transist", "Arrived at Dest", "Return to Hub"];

export const TillOFD = [
  "Booking Confirmed",
  PICKED,
  "received at hub",
  "Load to Dest",
  "Arrived at Transist",
  "Hold at Terminal",
  ARRIVED_AT_DEST,
];

export const isCODUpdate = (lastStatus) => TillOFD?.map(status => status?.toLowerCase())?.includes(lastStatus?.toLowerCase());

export enum POD_STATUS_ENUM {
  EXCEPTION = "Exception",
  COLLECTED = "Collected",
  CANNOT_BE_COLLECTED = "Cannot be Collected",
  COLLECTION_PENDING = "Collection Pending",
  PICKED_UP = "Picked up"
}

export const CNDN_MANIFESTER_POSITIONS = isProdMode() ? [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER] : [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.MANAGER];
export const CNDN_DIRECTOR_POSITIONS = [UserEnum.MANAGER];
export const CNDN_FINANCE_POSITIONS = [UserEnum.FINANCE_CONTROLLER];

export const DEFAULT_CURRENT = 0, DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_CURRENT_START_ONE = 1;


export const getProductDetails = (products, productId, subProductId) => {
  const product = products.find(p => p.productId === productId);
  if (!product) return { subProductList: [], temperatureList: [] };

  const subProduct = product.subProductList.find(sp => sp.subProductId === subProductId);
  if (!subProduct) return { subProductList: [], temperatureList: [] };

  return {
    subProductList: product.subProductList?.map((val) => ({
      ...val, id: val?.subProductId,
      value: val?.subProductName,
    })), temperatureList: subProduct.temperatureList?.map((val) => ({
      ...val,
      id: val?.temperatureId,
      value: val?.temperature,
    }))
  };
};


export const Marken_Team = [
  // Employee?.AAMIR_MEHBOOB,
  // Employee?.LLOYD_D_SARINO,
  // Employee?.FAISAL_HAKAMI,
  // Employee?.MOHAMMED_IMRAN,
  Employee?.MATEEN_PROD,
];

export const isMarkenTeam = () =>
  isProdMode()
    ? isAccessible(
      Marken_Team,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : isAccessible([Employee.PRANEETH_DEV, Employee.MATEEN_DEV], [CountryEnum.KSA], true);

export const EDIT_ODOMETER_TEAM = [
  Employee.SHIVRIN
];

export const isEditOdometerTeam = () =>
  isProdMode()
    ? isAccessible(
      EDIT_ODOMETER_TEAM,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;

export const FUEL_REPORT_TEAM = [
  Employee.ARWA_FINANCE,
  Employee.BANDER_ALLAFI
];

export const isFuelReportTeam = () =>
  isProdMode()
    ? isAccessible(
      FUEL_REPORT_TEAM,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;

export const SHIPMENT_SUMMARY_TEAM = [
  Employee.BANDER_ALLAFI
];

export const isShipmentSummaryTeam = () =>
  isProdMode()
    ? isAccessible(
      SHIPMENT_SUMMARY_TEAM,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;

export const IDLE_VEHICLE_EXCEPTION_TEAM = [
  Employee.TURKI_ALBUWAYDI
];

export const isIdleVehicleExceptionTeam = () =>
  isProdMode()
    ? isAccessible(
      IDLE_VEHICLE_EXCEPTION_TEAM,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;

export const EDIT_VEHICLE_TEAM = [
  Employee.KHUSBEER_SINGH,
  Employee.MAHAMED_ARIF_SHAH_MADAR,
  Employee.PRATHYOOD_JAGADEESH,
  Employee.ELEMAM_ELEMAM,
  Employee.Muath_Al_Abdulmunem
];

export const isEditVehicleTeam = () =>
  isProdMode()
    ? isAccessible(
      EDIT_VEHICLE_TEAM,
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;


export const MANIFEST_IRS_ACCESS = [
  Employee.Nouf_AlOmar
];

export const isManifestIrsAccess = () => isAccessible(
  MANIFEST_IRS_ACCESS,
  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
  true
);

export const getTempsFromTempRange = (tempRange: string) => {
  // tempRange - "+10 to 20", "-10 to -20", "-20 to -10"
  const temps = tempRange.split("to");
  const oneTemp = parseInt(temps?.[0].trim(), 10);
  const otherTemp = parseInt(temps?.[1].trim(), 10);

  let lowTemp, highTemp;
  if (oneTemp < otherTemp) {
    lowTemp = oneTemp;
    highTemp = otherTemp;
  } else {
    lowTemp = otherTemp;
    highTemp = oneTemp;
  }

  return {
    lowTemp,
    highTemp
  };
}

export const isNullish = (value: any) => value === null || value === undefined || value === "";

export const isEmpLuqman: boolean = isAccessible(
  [Employee.MOHAMMED_LUQMAN],
  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
  true
) ?? false;
export const isDRERangeFixed = (productId: number, primaryUnitId: number, secondaryUnitId: number): boolean => {
  if (!productId || !primaryUnitId || !secondaryUnitId) return false;
  const isRangeFixed = productId === DOMESTIC_ROAD_EXPRESS && primaryUnitId === KILOGRAM_UNIT && secondaryUnitId === RANGE_FIXED;
  const isRangeBasedFixed = productId === DOMESTIC_ROAD_EXPRESS && primaryUnitId === KILOGRAM_UNIT && secondaryUnitId === RANGE_BASED_FIXED;
  return !!(isRangeFixed || isRangeBasedFixed);
}

export const isFixedRangeKG = (primaryUnitId: number, secondaryUnitId: number): boolean => {
  if (!primaryUnitId || !secondaryUnitId) return false;
  return primaryUnitId === KILOGRAM_UNIT && secondaryUnitId === RangePriceID;
}

export const isKgMultiplierProduct = (primaryUnitId: number, secondaryUnitId: number): boolean => {
  if (!primaryUnitId || !secondaryUnitId) return false;
  return primaryUnitId === KILOGRAM_UNIT && secondaryUnitId === MULTIPLIER_UNIT;
}

// export const isDRERangeBaseFixed = (productId: number, primaryUnitId: number, secondaryUnitId: number) => {
//   if (!productId || !primaryUnitId || !secondaryUnitId) return false;
//   return productId === DOMESTIC_ROAD_EXPRESS && primaryUnitId === KILOGRAM_UNIT && secondaryUnitId === RANGE_BASED_FIXED
// }
export const ScanByPosition = {
  positionList: [
    UserEnum?.MANAGER,
    UserEnum?.OPS_MANAGER,
    UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
    UserEnum?.OPERATION_SUPERVISOR,
    UserEnum?.OPERATION_CS_SUPERVISOR,
    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
    UserEnum?.OPERATION_STAFF,
    UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
    UserEnum?.OPS_CASH
  ]
};

export const handleTrimOnBlur = (form, name) => (e) => {
  const fieldName = e.target.name;
  const trimmedValue = e.target.value.trim();
  form.setFieldValue(name || fieldName, trimmedValue);
};
export const createFormData = (file: File, fileType: string, category: string, categoryId: number) => {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("category", category);
  formData.append("fileType", fileType);
  formData.append("categoryId", `${categoryId}`);
  formData.append("generic", "true");
  return formData;
};

export const EmployeeMasterAccess = [Employee.ASIF_PATEL, Employee.PANDI, Employee.MAJAD_ALI, Employee.MATEEN_PROD, Employee.PRANEETH]
export const getMimeType = (fileFormat: string) => {
  const mimeTypes: Record<string, string> = {
    pdf: "application/pdf",
    excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    png: "image/png",
    txt: "text/plain",
    csv: "text/csv",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    zip: "application/zip",
  };

  const lowerCaseFormat = fileFormat.toLowerCase();

  for (const key in mimeTypes) {
    if (lowerCaseFormat.includes(key)) {
      return mimeTypes[key];
    }
  }

  return "application/octet-stream"; // Fallback MIME type
};

export const MARKEN_CUSTOMER_LIST = [
  { value: MARKEN_CUSTOMER_ID, name: "MARKEN Ltd - AJ000116001" },
  { value: 1144, name: "Marken-Unilab -AJ000116002" },
  { value: 1580, name: "AJEX - KSA - FFD (CCN) -AJ0000000029012" },
];

/*--------------------------------------------------------------------*/
export const TRIP_PLAN_MENU = "Trip Plan New";

export const TRIP_PLAN_APP = "/trip-plan/";

export const MENU_APP_MAP = Object.freeze({
  [TRIP_PLAN_MENU]: TRIP_PLAN_APP,
});

export const APP_MENU_MAP = Object.freeze({
  [TRIP_PLAN_APP]: TRIP_PLAN_MENU,
});
/*--------------------------------------------------------------------*/
export const isDuplicate = (list: any[], key: string, value: any, currentIndex: number) => {
  return list.some((item, index) => index !== currentIndex && item?.[key] === value);
};

export const isMateenProdUser = () =>
  isProdMode()
    ? isAccessible(
      [Employee.MATEEN_PROD],
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : false;

export const showMetabaseReports = true;
const lifeScienceProducts = [20, 21, 39]

export const isLifeScienceProduct = (id?: number) => id ? lifeScienceProducts?.includes(id) : false;


export enum TripPlanStatusEnum {
  Open = "Open",
  Cancelled = "Cancelled",
  Closed = "Closed",
  LoadToDestination = "Load To Destination",
  OffloadAtTransit = "Offload At Transit",
  LoadAtTransit = "Load At Transit",
  ArrivedAtDestination = "Arrived At Destination",
}


export const PodDownloadAccessUsers = [
  Employee.SAFAA_MOHAMMED_HAWSAWI,
  Employee.GHADEER_ALQHTANI,
  Employee.ALMAHA_ALANAZI,
  Employee.JAMELAH_IBRAHIM_ALI,
  Employee.Almaha_Alanazi,
  Employee.Faisal_Abdullah_Nasser,
];

export const PodDownloadAccess = isAccessible(
  PodDownloadAccessUsers,
  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
  true
)

export const isValidHttpsUrl = (testUrl: string) => {
  try {
    const url = new URL(testUrl);
    return url.protocol === "https:";
  } catch {
    return false;
  }
}

export const CUMULATIVE_PRODUCTS = [
  PRODUCT_TYPE.DOMESTIC_ROAD_EXPRESS,
  PRODUCT_TYPE.INTERNATIONAL_ROAD_FREIGHT_EXPRESS,
  PRODUCT_TYPE.DOMESTIC_TEMP_EXPRESS,
  PRODUCT_TYPE.INTERNATIONAL_TEMP_EXPRESS,
  PRODUCT_TYPE.LIFE_SCIENCE_EXPRESS,
  PRODUCT_TYPE.LIFE_SCIENCE_EXPRESS_PLUS,
  PRODUCT_TYPE.INTERNATIONAL_ROAD_EXPRESS,
];
const COLD_SUBSTRING = "C";
const COLD_SUBSTRING_POSITION = 2;
export const isCold = (fleetCode: string) => fleetCode ? fleetCode?.toLowerCase().indexOf(COLD_SUBSTRING.toLowerCase(), COLD_SUBSTRING_POSITION) === COLD_SUBSTRING_POSITION : false;

export const isMateenUser = () =>
  isProdMode()
    ? isAccessible(
      [Employee.MATEEN_PROD],
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    )
    : isAccessible(
      [Employee.MATEEN_DEV],
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      true
    );


export const googleMapNavigation = (lat: number | undefined, lng: number | undefined) => {
  const url = `https://maps.google.com?q=${lat},${lng}`;
  window.open(url, "_blank");
};

export const copyText = (text: string) => {
  navigator.clipboard.writeText(text)
  notification.open({
    message: `Copied: ${text}`,
    style: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid #b7eb8f',
      backgroundColor: '#f6ffed'
    }
  });
};

export const isRoaaArnaoutUser = () =>
  isAccessible(
    [Employee.Roaa_Arnaout],
    [CountryEnum.UAE, CountryEnum.BAHRAIN, CountryEnum.KSA],
    true
  );

interface MarkerOptions {
  letter: string;
  color?: string;
  size?: number;
  asIcon?: "leaflet" | "svg";
  circleBorderColor?: string; // optional circle border
  circleBorderWidth?: number;
  letterColor?: string;       // optional letter color
  letterBorderColor?: string; // optional letter border
  letterBorderWidth?: number;
  className?: string;
  style?: string;
}

export function customLetterMarker({
  letter,
  color = "#FFA500",
  size = 48,
  asIcon = "leaflet",
  circleBorderColor = "#000",
  circleBorderWidth = 0,
  letterColor = "#fff",
  letterBorderColor = "#000",
  letterBorderWidth = 0,
  className
}: MarkerOptions): string | DivIcon {
  const center = size / 2;
  const outerRadius = center;
  const innerRadius = size * 0.42;

  const svg = `
    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
      <!-- Outer white border -->
      <circle cx="${center}" cy="${center}" r="${outerRadius}" fill="#fff"/>
      
      <!-- Inner colored circle with border -->
      <circle
        cx="${center}"
        cy="${center}"
        r="${innerRadius}"
        fill="${color}"
        stroke="${circleBorderColor}"
        stroke-width="${circleBorderWidth}"
      />
      
      <!-- Letter in center with border -->
      <text
        x="${center}"
        y="${center + innerRadius * 0.15}"
        text-anchor="middle"
        dominant-baseline="middle"
        font-family="Arial, sans-serif"
        font-size="${innerRadius}"
        font-weight="bold"
        fill="${letterColor}"
        stroke="${letterBorderColor}"
        stroke-width="${letterBorderWidth}"
        paint-order="stroke fill"
      >
        ${letter}
      </text>
    </svg>
  `;

  return asIcon === "svg"
    ? `data:image/svg+xml;base64,${btoa(svg)}`
    : L.divIcon({
      html: svg,
      iconSize: [size, size],
      iconAnchor: [center, center],
      className: className
    });
}

export function offsetDuplicateCoordinates(lat: number, lng: number, count = 1, offsetMeters = 5): LatLng {
  const latOffset = (offsetMeters * count) / 111320;
  const lngOffset =
    (offsetMeters * count) /
    (111320 * Math.cos((lat * Math.PI) / 180));

  const latitude = lat + latOffset;
  const longitude = lng + lngOffset;

  return [latitude, longitude];
}

export const exportJsonToExcel = (
  data: Array<any>,
  fileName = "AJEX_TMS.xlsx",
  sheetName = "Sheet 1"
): boolean => {
  try {
    // Validate input
    if (!data || !Array.isArray(data)) {
      message.error("Invalid data format");
      return false;
    }

    if (data.length === 0) {
      message.error("No data available to export");
      return false;
    }

    // Sanitize filename - remove spaces and special chars
    const sanitizedFileName = fileName.trim() || "AJEX_TMS.xlsx";

    // Ensure .xlsx extension
    const finalFileName = sanitizedFileName.endsWith('.xlsx')
      ? sanitizedFileName
      : `${sanitizedFileName}.xlsx`;

    // Sanitize sheet name (Excel has 31 char limit and restricted chars)
    const sanitizedSheetName = sheetName
      .replace(/[:\\\/\?\*\[\]]/g, '') // Remove invalid chars
      .slice(0, 31) // Excel limit
      .trim() || "Sheet1";

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sanitizedSheetName);
    XLSX.writeFile(workbook, finalFileName);

    message.success(`File exported successfully: ${finalFileName}`);
    return true;

  } catch (err) {
    console.error("Error occurred in exportJsonToExcel function:", err);
    message.error("Failed to export file. Please try again.");
    return false;
  }
};

export const customLeafletIcon = (img: string, size?: [number, number]) =>
  L.icon({
    iconUrl: img,
    iconSize: size || [32, 32],      // default size if not provided
    iconAnchor: size
      ? [size[0] / 2, size[1]]       // center-bottom anchor for custom size
      : [16, 32],
  });

export const copyToClipboard = async (text: string, label: string) => {
  await navigator.clipboard.writeText(text);
  message.success(`${label} copied to clipboard`);
}

export const hexToRgb = (hex: string): [number, number, number] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : [0, 0, 0];
};

export const isAoneUrl = (): boolean =>
  window.location.pathname.startsWith('/a-one');

// RTO waybills are generated with an "RTO" prefix, e.g. RTO1001000161
export const isRtoWaybill = (waybillNo?: string | null): boolean =>
  /^RTO/i.test(waybillNo?.trim() ?? '');
export enum BusinessGroupEnum {
  GOVERNMENT = 1,
  PRIVATE = 2,
};

export const businessGroupList = [
  {
    "id": 1,
    "name": "Government",
    "createdDate": "2024-11-05T09:14:37"
  },
  {
    "id": 2,
    "name": "Private",
    "createdDate": "2024-11-05T09:14:37"
  }
]
export const toStringArray = (input: string) => {
  return input
    .split(/[,\s]+/)   // split by comma OR any whitespace
    .map(s => s.trim())
    .filter(Boolean);  // remove empty strings
};
